<script lang="ts">
	import { cn } from '$lib/utils';
	import { onDestroy } from 'svelte';
	import { inview } from 'svelte-inview';
	import { PUBLIC_CDN_URL, PUBLIC_LOL_CDN_URL } from '$env/static/public';

	let animating = false;
	const options = {};

	let intervalId: number | undefined;

	function startAnimation() {
		clearInterval(intervalId);
		intervalId = setInterval(() => {
			animating = !animating;
		}, 4000);
	}

	onDestroy(() => {
		clearInterval(intervalId);
	});
</script>

<div
	use:inview={options}
	on:inview_enter={() => {
		startAnimation();
	}}
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary group relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all"
	role="figure"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div class="relative row-span-3 flex h-full w-full flex-row items-center justify-center">
			<div
				class={cn(
					'border-darkQuaternary bg-darkSecondary relative z-20 overflow-hidden rounded-full border transition-all duration-300 group-hover:h-32 group-hover:w-32',
					animating ? 'h-32 w-32' : 'h-20 w-20'
				)}
			>
				<enhanced:img
					class={cn(
						'absolute object-cover transition-all duration-300 group-hover:h-32',
						animating ? '-bottom-8 h-32' : '-bottom-5 h-20'
					)}
					loading="lazy"
					src="/static/images/meeko/mascot/meeko_1.webp"
					alt="Meeko"
				/>
			</div>
			<enhanced:img
				loading="lazy"
				src="/static/images/lol/cooldown.svg"
				class={cn(
					'border-darkQuaternary bg-darkSecondary absolute rounded-full border p-2 transition-all duration-300 group-hover:bottom-10 group-hover:right-32 group-hover:h-0 group-hover:w-0',
					animating ? 'bottom-10 right-32 h-0 w-0' : 'bottom-4 right-10 h-10 w-10'
				)}
				alt="game-knowledge-1"
			/>
			<enhanced:img
				loading="lazy"
				src="/static/images/lol/stat-mods/StatModsArmorIcon.png"
				class={cn(
					'border-darkQuaternary bg-darkSecondary absolute rounded-full border p-1 transition-all duration-300 group-hover:right-32 group-hover:top-10 group-hover:h-0 group-hover:w-0',
					animating ? 'right-32 top-10 h-0 w-0' : 'right-16 top-0 h-7 w-7'
				)}
				alt="game-knowledge-2"
			/>
			<img
				loading="lazy"
				src={`${PUBLIC_LOL_CDN_URL}/item/1035.png?fm=webp`}
				class={cn(
					'border-darkQuaternary bg-darkSecondary absolute rounded-full border transition-all duration-300 group-hover:bottom-10 group-hover:left-32 group-hover:h-0 group-hover:w-0',
					animating ? 'bottom-10 left-32 h-0 w-0' : 'bottom-6 left-16 h-7 w-7'
				)}
				alt="game-knowledge-3"
			/>
			<enhanced:img
				loading="lazy"
				src="/static/images/lol/stat-mods/StatModsAttackSpeedIcon.png"
				class={cn(
					'border-darkQuaternary bg-darkSecondary absolute rounded-full border p-1 transition-all duration-300 group-hover:left-32 group-hover:top-10 group-hover:h-0 group-hover:w-0',
					animating ? 'left-32 top-10 h-0 w-0' : 'left-12 top-2 h-9 w-9'
				)}
				alt="game-knowledge-4"
			/>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">General Game Knowledge</h3>
			<p class="text-lightTertiary">
				Meeko also has general game knowledge such as champion spell cooldowns and item prices, so
				don’t feel limited by the examples shown here.
			</p>
		</div>
	</div>
</div>
